import React, { useState } from "react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "./DataTable";
import { Accordion, AccordionSummary, AccordionDetails, Box, Chip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SoftTypography from "components/SoftTypography";
import ReferredUsersTable from "./ReferredUsersTable";
import AllUsersTable from "./AllUsersTable";
import { 
  StorefrontOutlined, 
  PeopleOutlineRounded, 
  SupervisorAccountOutlined 
} from "@mui/icons-material";

const Customers = () => {
  const [rows, setRows] = useState([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(8);
  const [loading, setLoading] = useState(false);
  const [expandedSection, setExpandedSection] = useState("customers");
  
  const handleEntriesChange = (newEntries) => {
    setEntriesPerPage(newEntries);
    setPage(1);
  };

  const handleAccordionChange = (section) => (event, isExpanded) => {
    setExpandedSection(isExpanded ? section : false);
  };

  const customerColumns = [
    { Header: "Domain", accessor: "website", align: "left" },
    { Header: "No of Queries", accessor: "total_queries", align: "left" },
    { Header: "Source", accessor: "source", align: "left" },
    { Header: "Registered on", accessor: "registered_on", align: "left" },
  ];
  
  const customerTable = {
    columns: customerColumns,
    rows: rows
  };

  const sections = [
    {
      id: "customers",
      title: "Registered Webistes",
      icon: StorefrontOutlined,
      count: totalEntries,
      color: "#0d9488",
      bgColor: "linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)",
      component: (
        <DataTable
          table={customerTable}
          entriesPerPage={{
            defaultValue: entriesPerPage,
            entries: [5, 10, 15],
          }}
          canSearch
          date
          csv
          showTotalEntries
          onEntriesChange={handleEntriesChange}
          totalPages={Math.ceil(totalEntries / entriesPerPage)}
        />
      )
    },
    {
      id: "referredUsers",
      title: "Referred Users",
      icon: PeopleOutlineRounded,
      count: 0,
      color: "#0891b2",
      bgColor: "linear-gradient(135deg, #08b2a9ff 0%, #06b6d4 100%)",
      component: <ReferredUsersTable />
    },
    {
      id: "allUsers",
      title: "All Admin Users & Whitelabel Management",
      icon: SupervisorAccountOutlined,
      count: 0,
      color: "#0e7490",
      bgColor: "linear-gradient(135deg, #0e908aff 0%, #0891b2 100%)",
      component: <AllUsersTable />
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={3} mb={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="h4" fontWeight="bold" color="dark">
            Customer Management
          </SoftTypography>
          {/* <SoftTypography variant="body2" color="text" mt={0.5}>
            Manage customers, referrals, and user accounts in one place
          </SoftTypography> */}
        </SoftBox>

        <Card
          sx={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(13, 148, 136, 0.1)",
            boxShadow: "0 8px 32px rgba(13, 148, 136, 0.08)"
          }}
        >
          <SoftBox p={3}>
            {loading ? (
              <Box 
                display="flex" 
                justifyContent="center" 
                alignItems="center" 
                minHeight="300px"
              >
                <SoftTypography variant="body1" color="text">
                  Loading data...
                </SoftTypography>
              </Box>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {sections.map((section, index) => (
                  <Accordion
                    key={section.id}
                    expanded={expandedSection === section.id}
                    onChange={handleAccordionChange(section.id)}
                    sx={{
                      boxShadow: expandedSection === section.id 
                        ? "0 4px 20px rgba(13, 148, 136, 0.15)" 
                        : "0 2px 12px rgba(0, 0, 0, 0.04)",
                      border: expandedSection === section.id
                        ? `2px solid ${section.color}`
                        : "1px solid rgba(0, 0, 0, 0.08)",
                      borderRadius: "12px !important",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      "&:before": { display: "none" },
                      "&:hover": {
                        boxShadow: "0 4px 20px rgba(13, 148, 136, 0.12)",
                        transform: "translateY(-2px)"
                      }
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon 
                          sx={{ 
                            color: expandedSection === section.id ? section.color : "#64748b",
                            fontSize: "28px"
                          }} 
                        />
                      }
                      sx={{
                        background: expandedSection === section.id 
                          ? `linear-gradient(135deg, ${section.color}08 0%, ${section.color}15 100%)`
                          : "#ffffff",
                        borderBottom: expandedSection === section.id 
                          ? `1px solid ${section.color}20` 
                          : "none",
                        borderRadius: expandedSection === section.id 
                          ? "10px 10px 0 0" 
                          : "10px",
                        minHeight: "80px !important",
                        padding: "0 24px",
                        transition: "all 0.3s ease",
                        "& .MuiAccordionSummary-content": {
                          margin: "16px 0 !important",
                          display: "flex",
                          alignItems: "center",
                          gap: 2
                        }
                      }}
                    >
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: "12px",
                          background: section.bgColor,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: `0 4px 14px ${section.color}30`,
                          transition: "transform 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.05)"
                          }
                        }}
                      >
                        <section.icon sx={{ color: "#ffffff", fontSize: 24 }} />
                      </Box>
                      
                      <Box sx={{ flex: 1 }}>
                        <SoftTypography 
                          variant="h5" 
                          fontWeight="bold"
                          sx={{ 
                            color: expandedSection === section.id ? section.color : "#1e293b",
                            mb: 0.5
                          }}
                        >
                          {section.title}
                        </SoftTypography>
                        <SoftTypography 
                          variant="caption" 
                          color="text"
                          sx={{ opacity: 0.7 }}
                        >
                          {section.subtitle}
                        </SoftTypography>
                      </Box>

                      {section.count > 0 && (
                        <Chip
                          label={`${section.count} items`}
                          size="small"
                          sx={{
                            background: section.bgColor,
                            color: "#ffffff",
                            fontWeight: 600,
                            fontSize: "0.75rem",
                            height: 28,
                            boxShadow: `0 2px 8px ${section.color}25`
                          }}
                        />
                      )}
                    </AccordionSummary>
                    
                    <AccordionDetails 
                      sx={{ 
                        padding: 0,
                        background: "#fafafa"
                      }}
                    >
                      <SoftBox p={3}>
                        {section.component}
                      </SoftBox>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            )}
          </SoftBox>
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
};

export default Customers;